const user = JSON.parse(localStorage.getItem("user"));

const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

const Auth = (state = initialState, action) => {
  switch (action.type) {
    case "REGISTER_SUCCESS":
      state = {
        ...state,
        isLoggedIn: false,
      }
      return state
    case "REGISTER_FAIL":
      state = {
        ...state,
        isLoggedIn: false,
      }
      return state
    case "LOGIN_SUCCESS":
      state = {
        ...state,
        isLoggedIn: true,
        user: action.payload?.user?.data?.data ?? null
      }
      return state
    case "LOGIN_FAIL":
      state = {
        ...state,
        isLoggedIn: false,
        user: null
      }
      return state
    case "LOGOUT":
      localStorage.removeItem('user')
      state = {
        ...state,
        isLoggedIn: false,
        user: null
      }
      return state
    default:
      return state
  }
};
export default Auth;
